import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertControlGroupMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetControlGroupsFlatDocument,
  InsertControlGroupDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertControlGroupInput = {
  Title: string;
  Description: string;
  Owner: string;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertControlGroup = createMutationHook({
  name: 'insertControlGroup',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.controlGroup.insert.mutationOptions({ onSuccess }),
  mapInput: (input: InsertControlGroupInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.controlGroup.controlGroups.queryKey(),
    trpc.frontend.controlGroup.controlGroupById.queryKey(),
    trpc.frontend.controlGroup.controlGroupsByTitle.queryKey(),
    trpc.frontend.controlGroup.register.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertControlGroupMutation => ({
    insert_control_group_one: {
      __typename: 'control_group',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertControlGroupDocument,
  graphqlVariables: (input: InsertControlGroupInput) => ({ ...input }),
  evictFields: ['control_group', 'control_group_aggregate'],
  refetchQueries: [{ query: GetControlGroupsFlatDocument }],
  awaitRefetchQueries: true,
});
